import React, { useState } from 'react';
import { Button, Grid, Paper, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Typography from '@material-ui/core/Typography';
import { saveAs } from 'file-saver';
import { QAIssuesTable } from './QAIssuesTable';
import { QACard } from './QACard';
import useStyles from '../../../assets/jss/dashboardSection-styles';
import { instance as axios } from 'utils/axios-config';

export const QAWidget = (props) => {
  const classes = useStyles(props)();
  if (props.data) {
    let totalCount = 0;
    props.data.forEach((entry) => {
      totalCount += entry.issues.length;
    });
    return (
      <Grid item xs={12} md={4}>
        <Paper className={classes.sectionWrapper} elevation={0}>
          <QACard type='QAIssues' message='QA Issues that need to be addressed' count={totalCount} />
        </Paper>
      </Grid>
    );
  }
  return null;
};

export const QASection = (props) => {
  const classes = useStyles(props)();
  const [exporting, setExporting] = useState(false);

  const handleQaIssueExport = async (fromDate, toDate) => {

    setExporting(true);
    const params = {};
    if (fromDate) {
      params.fromDate = fromDate;
    }
    if (toDate) {
      params.toDate = toDate;
    }

    await axios({
      url: `/Issue/export`,
      responseType: 'blob',
      params: params
    })
      .then((response) => {
        saveAs(response.data, `issue-export.csv`);
      })
      .then(() => {
        setExporting(false);
      });
  }

  const handleQuarterToDateIssueExport = async () => {
    const now = new Date();
    const month = now.getMonth();
    const year = now.getFullYear();

    let fromDate;
    if (month <= 3) { // Q1
      fromDate = `${year}-01-01`;
    }
    else if (month <= 6) { // Q2
      fromDate = `${year}-04-01`;
    }
    else if (month <= 9) { // Q3
      fromDate = `${year}-07-01`;
    }
    else if (month <= 12) { // Q4
      fromDate = `${year}-10-01`;
    }

    await handleQaIssueExport(fromDate);
  }

  const handleExportingClose = () => {
    setExporting(false);
  }

  if (props.data) {
    const rows = props.data;
    return (
      <Grid item xs={12}>
        <Paper className={classes.sectionWrapper} elevation={0}>
          <Typography component='h2' variant='h6' className={classes.sectionLabel} fontWeight='fontWeightMedium'>
            {'All QA Issues'}
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <QAIssuesTable rows={rows} />
              <div className={classes.buttonContainer}>
                <Button variant='contained' color='primary' onClick={() => handleQuarterToDateIssueExport()}>
                  {'EXPORT QUARTER TO-DATE QA ISSUES'}
                </Button>
                <Button variant='contained' color='primary' onClick={() => handleQaIssueExport()}>
                  {'EXPORT TO-DATE QA ISSUES'}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
        <Snackbar open={exporting} onClose={handleExportingClose}>
          <Alert onClose={handleExportingClose} severity='warning'>
            {'Exporting...'}
          </Alert>
        </Snackbar>
      </Grid>
    );
  }
  return null;
};
